<template>
  <div>
    <div
      class="bookmark-bg container-fluid d-flex justify-content-center align-items-center"
    >
      <div class="container text-center">
        <div class="header mb-5">
          <img src="@/assets/pics/frame3/3.9/text.svg" alt="" />
        </div>
        <div class="data">
          <img src="@/assets/pics/frame3/3.9/shelftext.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookMark4.1",
};
</script>

<style scoped>
.bookmark-bg {
  background-color: #f8ef8f;
}
.data img,
.header img {
  width: 45%;
}
/* ipad */
@media (max-width: 821px) {
  .bookmark-bg {
    height: 80vh;
  }
  .data img,
  .header img {
    width: 90%;
  }
}
/* mobile */
@media (max-width: 540px) {
  .bookmark-bg {
    height: 60vh;
  }
}
</style>
